<template>

  <div class="row ml-0">
    <label class="p-1 text-success" v-if="checked">{{ text }} ativo</label>
    <label class="p-1 text-secondary" v-else>{{ text }} inativo</label>
    <b-form-checkbox v-model="checked" :disabled="formStatus === 'sending' || localDisabled" class="status-input-green"
                     :state="true" size="lg" switch></b-form-checkbox>
  </div>

</template>
<style>

</style>
<script>
export default {
  name: 't-input-status',
  props: {
    formStatus: {
      type: String,
      default: ""
    },
    formCommand: {
      type: String,
      default: 'insert'
    },
    text: {
      type: String,
      default: "Status",
    },
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: 0,
      localDisabled: false,
      checked: false,
    }
  },
  watch: {

    formCommand() {
      if (this.formCommand === 'view' || this.formCommand === 'delete') {
        this.localDisabled = true
      }
    },

    value(val) {

      this.innerValue = val

      if (this.innerValue === 1) {
        this.checked = true
      } else {
        this.checked = false
      }

    },

    checked(val) {

      if (val) {
        this.innerValue = 1

      } else {
        this.innerValue = 2
      }

      this.$emit("input", this.innerValue);

    }

    /*innerValue(value) {

      if (value === 1) {
        this.checked = true
      } else {
        this.checked = false
      }

    },
    */
  },
  mounted() {

    this.localDisabled = this.disabled
    this.innerValue = this.value;


    if (this.innerValue === 1) {
      this.checked = true
    } else {
      this.checked = false
    }


  },

}
</script>
<style>

</style>
